import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { publicRoutes, adminRoutes } from "./routes/";
import {AdminPrivateRoute,AuthRoute} from "./routes/route";
import PublicLayout from "./layouts/AuthenticationLayout";
import ProtectedLayout from "./layouts/ProtectedLayout";
import "./assets/scss/app.scss"
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import 'react-loading-skeleton/dist/skeleton.css'
import Error404 from "./pages/Error/404";
import TourManager from "./components/TourManager";
import CompletionModal from "./components/CompletionModal";
import QuickStartModal from "./components/QuickStart/QuickStartModal";
import WidgetEmbed from "./pages/Widget/WidgetEmbed";

function App() {
  return (
    <BrowserRouter>
    <TourManager />
    <CompletionModal />
    <QuickStartModal />
      <Routes>
        {
          publicRoutes.map((route, idx) => (
            <Route exact key={`public-${idx}`} path={route.path} element={<AuthRoute> <PublicLayout> <route.element /> </PublicLayout> </AuthRoute>}/>
          ))
        }
        { 
          adminRoutes.map((route, idx) => (
            <Route exact key={`admin-${idx}`} path={route.path} element={ <AdminPrivateRoute> <ProtectedLayout key={route.path} allowedInTrail={route.allowedInTrail} showSideBar={route.sidebar !== undefined ? route.sidebar : true}> <route.element type={"admin"}/> </ProtectedLayout> </AdminPrivateRoute> }/>
          ))
        }
        <Route exact path="/widget" element={<WidgetEmbed />} />
        <Route exact path="*" element={<Error404/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
